export default __webpack_public_path__ + "/dist/images/image00023.0d0d9c3df1faec7320a0b4e1232f80f6.jpg";